// IMPORT PACKAGE REFERENCES
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// IMPORT PROJECT REFERENCES

import { fetchPharmacies, searchPharmacies } from '../State/Actions/PharmacyActions';
import { PharmacyList } from './PharmacyList';
import { PageToolbar } from './PageToolbar';
import { LoadingIndicator } from '../Shared/LoadingIndicator/LoadingIndicator';
import { Error } from '../Shared/Error/Error';
import { AddPharmacy } from './AddPharmacy';

// COMPONENT

class PharmacyBrowser extends Component {

    constructor(props) {
        super(props);

        this.search = this.search.bind(this);
    }

    componentDidMount() {
        this.props.fetchPharmacies();
    }
    
    search(searchText) {
        this.props.searchPharmacies(searchText);
    }

    render() {
        return (
            <div>
                <AddPharmacy />
                <PageToolbar placeholder={"Search pharmacies..."} rightComponent={<button type="button" className="right-detail btn btn-info" data-toggle="modal" data-target="#addDeviceModal">Add Pharmacy </button>}  search={this.search} />
                { this.props.fetched && (
                    <div className="container">
                        <PharmacyList pharmacies={this.props.filteredPharmacies} />
                    </div>
                )}
                { <LoadingIndicator busy={this.props.fetching} />}
                { this.props.failed && <Error message="Failed to fetch pharmacies." /> }
            </div>
        );
    }
}

PharmacyBrowser.propTypes = {
    fetchPharmacies: PropTypes.func.isRequired,
    fetched: PropTypes.bool.isRequired,
    fetching: PropTypes.bool.isRequired,
    failed: PropTypes.bool,
    pharmacies: PropTypes.array.isRequired
};


// CONFIGURE REACT REDUX
const mapStateToProps = state => {
    const { fetching, fetched, failed, filteredPharmacies, pharmacies, activeFilter } = state.pharmaciesReducer;
    return { fetching, fetched, failed, filteredPharmacies, pharmacies, activeFilter };
};

const mapDispatchToProps = dispatch => (
    bindActionCreators({ fetchPharmacies, searchPharmacies }, dispatch)
);

const hoc = connect(mapStateToProps, mapDispatchToProps)(PharmacyBrowser);


// EXPORT COMPONENT

export { hoc as PharmacyBrowser };